<template>
  <v-card class="jugador-card ringbearer">
    <v-card-title class="title">
      <h2>Mis torneos</h2>
    </v-card-title>
  </v-card>
</template>

<script setup lang="ts"></script>

<style scoped>
.jugador-card {
  max-width: 100%;
  min-width: 300px;
}
</style>
